import { render, staticRenderFns } from "./RegisterMobile.vue?vue&type=template&id=63ac14a9"
import script from "./RegisterMobile.vue?vue&type=script&lang=js"
export * from "./RegisterMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports